// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `@media screen and (max-width: 599px) {
  .sequences-dialog {
    width: 100%;
  }
}
@media screen and (min-width: 600px) {
  .sequences-dialog {
    width: 80%;
  }
}
.sequences-dialog .mat-mdc-dialog-container {
  padding: 0;
}
.sequences-dialog .mat-mdc-dialog-container .compose-form .mat-mdc-form-field {
  width: 100%;
}
.sequences-dialog .mat-mdc-dialog-container .compose-form .show-hide-extra-fields {
  text-align: right;
  cursor: pointer;
  font-size: 12px;
}
.sequences-dialog .mat-mdc-dialog-container .compose-form .attachment-list {
  font-size: 13px;
}
.sequences-dialog .mat-mdc-dialog-container .compose-form .attachment-list .attachment {
  border: 1px solid;
  border-radius: 20px;
  padding-left: 16px;
  margin-top: 8px;
}
.sequences-dialog .mat-mdc-dialog-container .compose-form .attachment-list .attachment .filename {
  font-weight: 600;
}
.sequences-dialog .mat-mdc-dialog-container .compose-form .attachment-list .attachment:last-child {
  margin-bottom: 0;
}
.sequences-dialog .dialog-content-wrapper {
  max-height: 85vh;
  display: flex;
  flex-direction: column;
}

app-sequences table {
  width: 100%;
}
app-sequences .mat-mdc-form-field-wrapper {
  padding: 0;
}
app-sequences .loading-shade {
  position: absolute;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  background: rgba(0, 0, 0, 0.15);
  z-index: 1000;
  display: flex;
  align-items: center;
  justify-content: center;
}

.ng-dropdown-panel {
  width: auto !important;
  max-width: 550px;
  min-width: 100%;
}`, "",{"version":3,"sources":["webpack://./src/@fuse/scss/partials/_breakpoints.scss","webpack://./src/app/directives/event-sequences/dialogs/sequences/sequences.component.scss"],"names":[],"mappings":"AAiCQ;EC/BR;IAEQ,WAAA;EADN;AACF;AD6BQ;EC/BR;IAMQ,UAAA;EAAN;AACF;AAEI;EACI,UAAA;AAAR;AAGY;EACI,WAAA;AADhB;AAIY;EACI,iBAAA;EACA,eAAA;EACA,eAAA;AAFhB;AAKY;EACI,eAAA;AAHhB;AAKgB;EACI,iBAAA;EACA,mBAAA;EACA,kBAAA;EACA,eAAA;AAHpB;AAKoB;EACI,gBAAA;AAHxB;AAMoB;EACI,gBAAA;AAJxB;AAWI;EACI,gBAAA;EACA,aAAA;EACA,sBAAA;AATR;;AAcI;EACI,WAAA;AAXR;AAaI;EACI,UAAA;AAXR;AAcI;EACI,kBAAA;EACA,MAAA;EACA,OAAA;EACA,SAAA;EACA,QAAA;EACA,+BAAA;EACA,aAAA;EACA,aAAA;EACA,mBAAA;EACA,uBAAA;AAZR;;AAgBA;EACI,sBAAA;EACA,gBAAA;EACA,eAAA;AAbJ","sourcesContent":["// Media step breakpoint mixin based on Angular Material lib\n$breakpoints: (\n    xs: 'screen and (max-width: 599px)',\n    sm: 'screen and (min-width: 600px) and (max-width: 959px)',\n    md: 'screen and (min-width: 960px) and (max-width: 1279px)',\n    lg: 'screen and (min-width: 1280px) and (max-width: 1919px)',\n    xl: 'screen and (min-width: 1920px) and (max-width: 5000px)',\n    lt-sm: 'screen and (max-width: 599px)',\n    lt-md: 'screen and (max-width: 959px)',\n    lt-lg: 'screen and (max-width: 1279px)',\n    lt-xl: 'screen and (max-width: 1919px)',\n    gt-xs: 'screen and (min-width: 600px)',\n    gt-sm: 'screen and (min-width: 960px)',\n    gt-md: 'screen and (min-width: 1280px)',\n    gt-lg: 'screen and (min-width: 1920px)'\n) !default;\n\n// Re-map the breakpoints for the helper classes\n$helper-breakpoints: (\n    xs: null,\n    sm: 'gt-xs',\n    md: 'gt-sm',\n    lg: 'gt-md',\n    xl: 'gt-lg'\n);\n\n@mixin media-breakpoint($breakpointName) {\n\n    $mediaQuery: map-get($breakpoints, $breakpointName);\n\n    @if ($mediaQuery == null) {\n        @content\n    } @else {\n        @media #{$mediaQuery} {\n            @content\n        }\n    }\n}\n","@import \"src/@fuse/scss/partials/breakpoints\";\n\n.sequences-dialog {\n    @include media-breakpoint('xs') {\n        width: 100%;\n    }\n\n    @include media-breakpoint('gt-xs') {\n        width: 80%;\n    }\n\n    .mat-mdc-dialog-container {\n        padding: 0;\n\n        .compose-form {\n            .mat-mdc-form-field {\n                width: 100%;\n            }\n\n            .show-hide-extra-fields {\n                text-align: right;\n                cursor: pointer;\n                font-size: 12px;\n            }\n\n            .attachment-list {\n                font-size: 13px;\n\n                .attachment {\n                    border: 1px solid;\n                    border-radius: 20px;\n                    padding-left: 16px;\n                    margin-top: 8px;\n\n                    .filename {\n                        font-weight: 600;\n                    }\n\n                    &:last-child {\n                        margin-bottom: 0;\n                    }\n                }\n            }\n        }\n    }\n\n    .dialog-content-wrapper {\n        max-height: 85vh;\n        display: flex;\n        flex-direction: column;\n    }\n}\n\napp-sequences {\n    table {\n        width: 100%;\n    }\n    .mat-mdc-form-field-wrapper {\n        padding: 0\n    }\n\n    .loading-shade {\n        position: absolute;\n        top: 0;\n        left: 0;\n        bottom: 0;\n        right: 0;\n        background: rgba(0, 0, 0, 0.15);\n        z-index: 1000;\n        display: flex;\n        align-items: center;\n        justify-content: center;\n    }\n}\n\n.ng-dropdown-panel {\n    width: auto !important;\n    max-width: 550px;\n    min-width: 100%;\n}"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
